import { render } from "./linkExpired.vue?vue&type=template&id=06ac9c75&scoped=true"
const script = {}

import "./linkExpired.vue?vue&type=style&index=0&id=06ac9c75&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ac9c75"]])

export default __exports__